import React from "react";
import { Navigate } from "react-router-dom";

/**
 * Phase 14 — Client Portal Management redirects to the unified PortalSettings page
 * where both client + employee portal access can be configured. The two-page split
 * was redundant and the underlying backend exposes a single /api/portal/* surface.
 */
export default function ClientPortalManagement() {
  return <Navigate to="/portal-settings" replace />;
}
